import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { NavLink,Link, withRouter  } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "../../axios";
import { AgGridReact } from "ag-grid-react";
import logo from "../../Assets/images/Swaasa.png";


// import { userLogout } from "../Actions";
import { connect } from "react-redux";



import { Grid, GridApi } from "ag-grid-community"; // the AG Grid React Component
import "ag-grid-community/styles/ag-grid.css";
// import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-material.css";

import { act } from "react-dom/test-utils";
import moment from "moment-timezone";
// import HashLoader from "react-spinners/HashLoader";
import exportIcon from '../../Assets/images/export.png';



const ClientsTable = (props) => {
  var dateFilterParams = {
    comparator: (dateFromFilter, cellValue) => {
      var dateAsString = cellValue;
      if (dateAsString == null) return -1;
      var actualdate = dateAsString.split(" ");
      var dateParts = actualdate[0].split("-");
      var cellDate = new Date(actualdate[0]);
      cellDate.setHours(0, 0, 0);
      console.log(cellDate, "==", dateFromFilter);
      console.log(cellDate == dateFromFilter);
      if (cellDate < dateFromFilter) {
        return -1;
      }
      if (cellDate > dateFromFilter) {
        return 1;
      }

      return 0;
    },
    browserDatePicker: true,
  };

  const [disable, setdisable] = useState(props.disable);

  const [lastKey, setLastKey] = useState(props.lastKey);

  const [dataArray, setDataArray] = useState(["", props.lastKey]);
  console.log(dataArray)
    
  useEffect(() => {
    console.log("nextarray", dataArray);
  }, [dataArray]);

  const getDoctors = async (Key) => {
    try {
      const response = await axios.get(`/getDoctors?last_e_key=${Key}?&page_limit=50`, {
        headers: {
          accessToken: localStorage.accessToken,
        },
      });
      setRowData(response.data.data.users);
      setLastKey(response.data.last_key);
      if (response.data.last_key === "e30=") {
        setdisable(true);
      } else {
        setdisable(false);
      }
      setDataArray((prevArray) => [...prevArray, response.data.last_key]);
      
    } catch (error) {
      console.log(error);
    }
  };


  const getprevDoctors = async (Key) => {
    try {
      const response = await axios.get(`/getDoctors?last_e_key=${Key}&page_limit=50`, {
        headers: {
          accessToken: localStorage.accessToken,
        },
      });
      setdisable(false);

      setRowData(response.data.data.users);
      setLastKey(response.data.last_key);
      setDataArray((prevArray) => [...prevArray, response.data.last_key]);
      
      // console.log(response.data);

    } catch (error) {
      console.log(error);
    }
  };

  const handlePrevPage = () => {
    const removedElement1 = dataArray.pop();
    const removedElement2 = dataArray.pop();
    console.log(dataArray);

    if (dataArray.length > 1) {
      getprevDoctors(dataArray[dataArray.length - 1]);
    } else {
      getprevDoctors("");
    }
  };

  const handleNextPage = () => {
    if (dataArray.length >= 1) {
      getDoctors(dataArray[dataArray.length - 1]);
    } 
    else {
      getDoctors("");
    }
  };

  const [rowData, setRowData] = useState(props.rows);

  const [columnDefs] = useState([
    { headerName: "Client",resizable: true, field: "hospitals",cellRendererFramework:(params)=>
    <NavLink
    
    to={`/clientadmin/${params.node.data.loginId}/${params.node.data.hospitals}`}
    // target={!localStorage.accessToken  ? "_self"  : "_blank" }
    target="_blank"
    className="table__row__item"
    >
      {params.value}
    </NavLink>},
    { headerName: "Assessments", field: "total_assessments" },
    { headerName: "Contact Details", field: "contact" },
    { headerName: "Plan", field: "plan" },
    { headerName: "Access Type", field: "accessType" },
    { headerName: "Created On", field: "createdOn",filter: "agDateColumnFilter",
    filterParams: dateFilterParams,
    width: 200, 
    cellRendererFramework: (params) => {
      
      const timezone = localStorage.timezone;
      if (timezone == "UTC") {
        return moment(params.value).format("YYYY-MM-DD hh:mm:ss");
      } else {
        const convertedDate = moment
          .tz(params.value, timezone)
          .format("YYYY-MM-DD hh:mm:ss");

        return convertedDate;
      }
    },},
 
    
    { headerName: "Email", field: "loginId"  },  
  ]);

  const defaultColDef = {
    // set every column width
    // width: 270,
    flex: 1,
    resizable:true,
    sortable: true,
    // make every column use 'text' filter by default
    filter: "agTextColumnFilter",
  };
  let gridApi;
  const onGridReady = (params) => {
    gridApi = params.api;
  };
  const exportData = () => {
    gridApi.exportDataAsCsv();
  };

  const [height, setWidth] = useState(window.innerHeight);

  const gridApiRef = useRef(null);


  // const exportToCsv = () => {
  //   const params = {
  //     fileName: 'data.csv',
  //     processCellCallback: (params) => {
  //       if (params.column.getColDef().field === 'contact' || params.column.getColDef().field === 'createdOn' || params.column.getColDef().field === 'patientId' || params.column.getColDef().field === ["records.length"])  {
  //         return `'${params.value}'`;
  //       }
  //       else if (params.column.getColDef().field === 'contact' || params.column.getColDef().field === 'createdOn' || params.column.getColDef().field === 'patientId' || params.column.getColDef().field === ["records.length"]) {
  //         const valueWithoutQuotes = `"${params.value}"`.slice(1, -1);
  //         return valueWithoutQuotes;
  //       }
  //       // return params.value;
  //       else {
  //         return params.value;
  //       }
        
  //     },
  //   };
  //   if (gridApiRef.current) {
  //     gridApiRef.current.exportDataAsCsv(params);
  //   }
  // };

  

  return (
    <div>
      {/* <img className="export_iconn" onClick={exportToCsv} src={exportIcon} alt=""  /> */}
      <p className="export_iconn2">Export</p>
      <div className="ag-theme-material" style={{ height: height - 200 }}>
        <AgGridReact
          defaultColDef={defaultColDef}
          // onGridReady={onGridReady}
          rowData={rowData}
          columnDefs={columnDefs}
          onGridReady={(params) => {
            gridApiRef.current = params.api;
          }}
        ></AgGridReact>
        
      </div>
      <div>
        <button className="nextButton" onClick={handlePrevPage} disabled={dataArray.length < 3}>
          Prev
        </button>
        <button className="nextButton" onClick={handleNextPage} disabled={disable === true}>
          Next
        </button>
      </div>
  </div>
  );
};

export default ClientsTable;
// const mapStateToProps = (state) => ({
//   doctors: state.doctors,
// });
// export default withRouter(connect(mapStateToProps, { userLogout })(ClientsTable));